import { Serializable } from '@admin/core/models/serializable';

export class CustomerAgentSmsSetting
  implements Serializable<CustomerAgentSmsSetting>
{
  public smsTypeId: number;
  public isOn: boolean;
  public charsetId: number; // if on
  public reasonId: number; // if off

  constructor(
    typeId?: number,
    isOn?: boolean,
    charsetId?: number,
    reasonId?: number
  ) {
    this.smsTypeId = typeId;
    this.isOn = isOn;
    this.charsetId = charsetId;
    this.reasonId = reasonId;
  }

  fromObject(object: any): CustomerAgentSmsSetting {
    Object.assign(this, object);
    return this;
  }

  toObject() {
    return {
      SmsTypeId: this.smsTypeId,
      IsOn: this.isOn,
      CharsetId: this.charsetId,
      ReasonId: this.reasonId,
    };
  }
}
